module.exports = __webpack_public_path__ + "img/thailand.87e953c9.svg";